var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"loading":_vm.loading}},[_c('v-system-bar',[_vm._v("Q-Arbeiten")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.itemsFiltered,"sort-by":"person"},scopedSlots:_vm._u([{key:"item.person",fn:function({ item }){return [_c('PersonItemBasic',{attrs:{"value":item.person}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }